import { KeyboardArrowRightOutlined, KeyboardArrowUpOutlined } from '@mui/icons-material';

export const ExpandIcon = () => <KeyboardArrowRightOutlined />;
export const CollapseIcon = () => <KeyboardArrowUpOutlined />;
